// extracted by mini-css-extract-plugin
module.exports = {"machineIcon":"style_machineIcon__3-rQc","machineImage":"style_machineImage__1Y6pO"};